/* This is just a static page to display when no conversation is selected. */
import React from 'react';
import { injectIntl } from 'react-intl';

const COPY = {
  en: {
    eyebrow: 'Personal virtual psychologist',
    title: 'Personal AI psychologist',
    tagline: 'PeaceTalk helps you understand what is happening and choose the next step',
    features: ['Clarify the problem without judgment', 'Get a personal plan and practical exercises', 'Return for support whenever you need it'],
    chips: ['Less anxiety', 'Clear action plan', 'Self-reflection practice'],
    stats: [
      { value: '24/7', label: 'support nearby' },
      { value: 'Plan', label: 'steps for your situation' },
      { value: 'Safe', label: 'confidential space' },
    ],
  },
  ru: {
    eyebrow: 'Личный виртуальный психолог',
    title: 'Личный AI-психолог',
    tagline: 'PeaceTalk помогает понять, что происходит, и выбрать следующий шаг',
    features: ['Разобраться в проблеме без осуждения', 'Получить личный план и практические упражнения', 'Возвращаться за поддержкой в любой момент'],
    chips: ['Меньше тревоги', 'Понятный план действий', 'Практика саморефлексии'],
    stats: [
      { value: '24/7', label: 'поддержка рядом' },
      { value: 'План', label: 'шаги под вашу ситуацию' },
      { value: 'Safe', label: 'конфиденциально' },
    ],
  },
};

class LogoView extends React.PureComponent {
  render() {
    const language = (this.props.intl?.locale || 'en').split(/[-_]/)[0];
    const copy = COPY[language] || COPY.en;

    return (
      <div id="dummy-view">
        <div className="dummy-view-card">
          <div className="dummy-view-eyebrow">{copy.eyebrow}</div>
          <div className="dummy-view-badge">
            <img id="logo" alt="logo" src="img/PeaceTalk.png" />
          </div>
          <div className="dummy-view-copy">
            <h2 className="dummy-view-title">{copy.title}</h2>
            <p className="dummy-view-tagline">{copy.tagline}</p>
            <ul className="dummy-view-features">
              {copy.features.map((feature) => (
                <li key={feature}><span className="dummy-view-feature-dot"></span>{feature}</li>
              ))}
            </ul>
            <div className="dummy-view-chips">
              {copy.chips.map((chip) => (
                <span className="dummy-view-chip" key={chip}>{chip}</span>
              ))}
            </div>
            <div className="dummy-view-stats">
              {copy.stats.map((stat) => (
                <div className="dummy-view-stat" key={stat.value + stat.label}>
                  <strong>{stat.value}</strong>
                  <span>{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default injectIntl(LogoView);
